import React from 'react';
import { AlertCircle, RefreshCw } from 'lucide-react';
import { useServerHealth } from '../hooks/useServerHealth';

const ServerStatus = () => {
  const { isHealthy, lastCheck, error, checkHealth } = useServerHealth();

  if (isHealthy) {
    return null; // Don't show anything when server is healthy
  }

  return (
    <div className="fixed top-0 left-0 right-0 bg-red-600 text-white p-3 z-50">
      <div className="flex items-center justify-between max-w-7xl mx-auto">
        <div className="flex items-center space-x-2">
          <AlertCircle className="w-5 h-5" />
          <span className="font-medium">Server Connection Lost</span>
          {error && <span className="text-red-200">- {error}</span>}
        </div>
        <div className="flex items-center space-x-4">
          {lastCheck && (
            <span className="text-red-200 text-sm">
              Last check: {lastCheck.toLocaleTimeString()}
            </span>
          )}
          <button
            onClick={checkHealth}
            className="flex items-center space-x-1 bg-red-700 hover:bg-red-800 px-3 py-1 rounded text-sm"
          >
            <RefreshCw className="w-4 h-4" />
            <span>Retry</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ServerStatus;